export default __webpack_public_path__ + "static/media/4_long.e0c8b0fa.svg";